import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MainStore } from '../../../layout/main-screen/services/main.store';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-kpi-expert-dashboard',
  templateUrl: './kpi-expert-dashboard.component.html',
  styleUrls: ['./kpi-expert-dashboard.component.css'],
})
export class KpiExpertDashboardComponent implements OnInit, OnChanges {
  @Input() icon = '';
  @Input() iconColor = '#FFF';
  @Input() iconBackgroundColor = '#FE5621';
  @Input() value = 0;
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() unit = '';
  @Input() boxTitle = '';
  @Input() loading = false;
  @Input() lastUpdated: Date;
  @Input() Tax = '';
  @Input() secondaryLabel = '';
  @Input() secondaryValue: number | string = '';

  @Input() status = '';
  selectedItem: string = null;
  private ngUnsubscribe$: Subject<undefined> = new Subject();
  constructor(private mainStore: MainStore) {}

  ngOnInit() {
    this.emitChange(this.selectedItem);
  }

  addUserLog(action: string) {
    //this.mainStore.addUserLog('EXPERT_CLICK_ON_DASHBOARD_VIEW_MISSIONS', null);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  emitChange(id) {
    this.onChange.emit(id);
    this.selectedItem = id;
  }

  ngOnChanges(changes: SimpleChanges): void {}
}
